import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Select, Button, Modal, Spin, message } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import {
  getLocations,
  getIsOnBreak,
  getIsCheckedIn,
  getCheckInLocationId,
  getPunchId,
  getBreakId,
  getShiftTimeMaster,
  getTime24,
  getDepartmentList,
  getAllDepartmentList,
  getUserInfo,
  getLongDay,
  getUserList,
  getClientid,
  getSelectedDepartmentId,
  getUserRoleId,
  getRoleList,
  getCheckInDepartmentId,
  getWeekendShifts,
  getMenuList,
  getShiftList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import {
  setIsOnBreak,
  toggleSuccessModal,
  setCheckedIn,
  setCheckInLocationId,
  toggleProcessingModal,
  setPunchId,
  setBreakId,
} from "redux/actions";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import CustomIcon from "atoms/Icon";
import BreakModal from "organisms/BreakModal";
import CheckInProblemModal from "organisms/CheckInProblemModal";
import { displayErrorModal } from "common/common";
import { PUNCH_ACTIONS, STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { concat, find, get, includes, size, result, orderBy } from "lodash";
import { DEVICE } from "common/Device";
import { dateInDetail, getMySqlDate, getKenyanDateTime } from "utils/Date";
import { Input } from "antd";

const StyleContainerRow = styled(Row)`
  background-color: #e3e8fc;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 2rem;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  .checkin-row {
    display: flex;
    align-items: center;
    margin-left: -1px;
  }
  @media (max-width: 767px) {
    .checkin-row {
      margin-left: 20px;
    }
  }
  @media (max-width: 628px) {
    .checkin-row {
      margin-left: 0px;
    }
  }
  @media (max-width: 576px) {
    margin-left: 0px;
  }

  @media (max-width: 376px) {
    .checkin-row {
      margin-top: 10px;
      margin-left: 0px;
      flex-wrap: wrap;
    }
  }

  // @media (max-width: 426px) {
  //   display: none;
  // }
`;

const StyledCheckInCheckOutButton = styled(Button)`
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  border: none !important;
  background: #3c5fdd;
  color: white;
  padding-left: 30px;
  padding-right: 30px;
  :hover {
    border: none !important;
    background: #3c5fdd !important;
    color: white !important;
  }
  @media (max-width: 321px) {
    margin-bottom: 0px;
  }
  @media ${DEVICE.mobileS} {
    margin-bottom: 5px;
    margin-left: 0px;
  }
`;

const StyledStartBreak = styled(Button)`
  font-size: 1rem;
  vertical-align: text-top;
  margin-top: 5px;
  background: white;
  border-radius: 6px;
  color: black !important;
  &:hover {
    background: white !important;
  }
  svg {
    margin-right: 8px;
    vertical-align: top;
    path {
      fill: #03c83e !important;
    }
  }
  @media (max-width: 376px) {
    font-size: 1rem;
    margin-left: -15px;
  }
`;
const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
const StyledLocationSelect = styled(Select)`
  // @media ${DEVICE.tablet} {
  //   width: initial;
  // }
  @media (max-width: 575px) {
    width: 120%;
  }
  @media (max-width: 426px) {
    width: 100%;
  }
  @media (max-width: 416px) {
    width: 100%;
  }
  margin-right: 15px;
  width: 160px;
`;

function CheckInCheckout({
  locationList,
  isOnBreak,
  isCheckedIn,
  updateIsOnBreak,
  updateSuccessModal,
  updateCheckedIn,
  updateCheckInLocationId,
  checkInLocationId,
  updateProcessingModal,
  punchId,
  breakId,
  savePunchId,
  saveBreakId,
  shiftTimeMaster,
  userInfo,
  userList,
  ClientId,
  userRoleId,
  roleList,
  AllDepartmentList,
  checkInDepartmentId,
  weekendShifts,
  menuList,
  shiftList,
}) {
  const [isBreakModalVisible, toggleDisplayBreakModal] = useState(false);
  const [isCheckInProblemModalVisible, toggleCheckInProblemModal] =
    useState(false);
  const [isCheckInReminderModalVisible, toggleCheckInReminderModal] =
    useState(false);
  const [locationId, setLocationId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [showLateCheckInModal, setShowLateCheckInModal] = useState(false);
  const [punchInOutReason, setPunchInOutReason] = useState("");
  const [reasonSubmited, setReasonSubmited] = useState(false);
  const [reasonValidation, setReasonValidation] = useState(false);
  const Menulist =
    menuList?.[userRoleId] || Object.values(menuList || {})[0] || [];
  const containerRef1 = useRef(null);
  const containerRef2 = useRef(null);
  const { TextArea } = Input;
  const [myShift, setMyShift] = useState([]);
  const [getShiftLoader, setShiftLoader] = useState(false);

  const today = new Date();
  const todayDay = today.getDay();
  const dateStr = moment().format("YYYY-MM-DD");
  const dateShift = myShift
    ?.flatMap((shift) => shift.dates)
    ?.find((d) => d.date === dateStr)?.shift_id;
  const findShift = shiftList?.find((val) => val?.shift_id === dateShift);
  const shiftStartTime = findShift?.starts
    ? moment(findShift?.starts).local().format("HH:mm")
    : "";

  const shiftEndTime = findShift?.ends
    ? moment(findShift?.ends).local().format("HH:mm")
    : "";
  const [locationError, setLocationError] = useState(false);

  const filterRoleList = roleList?.filter(
    (item) => item?.roleId === userRoleId
  );

  const filteruser = userList?.filter(
    (item) => item?.userid === get(userInfo, "userid", "")
  );

  const filterLocationId = filterRoleList[0]?.locationId;
  const filterLocation = locationList?.filter(
    (item) => filterLocationId?.includes(item?.location_id)
    //  ||
    //   item?.login_from_anywhere === 1
  );

  const filterDepartmentId = filterRoleList[0]?.department;
  const filterDepartment = AllDepartmentList?.filter((item) =>
    filterDepartmentId?.includes(item?.department_id)
  );

  useEffect(() => {
    setLocationId(checkInLocationId);
    setDepartmentId(checkInDepartmentId);
  }, [checkInLocationId, checkInDepartmentId]);

  useEffect(() => {}, [punchInOutReason, reasonSubmited]);

  const getPunchInOutReason = (action) => {
    if (punchInOutReason != "") {
      setReasonSubmited(true);
      setShowLateCheckInModal(false);
      setReasonValidation(false);
      punchInOutApiCal(action, "");
    } else {
      setReasonValidation(true);
    }
  };
  const handlePunchInOutReason = (e) => {
    setPunchInOutReason(e.target.value);
    if (e.target.value.length > 1) {
      setReasonValidation(false);
    }
  };
  const hideModal = () => {
    setShowLateCheckInModal(false);
  };
  const startBreak = (breakTypeId) => {
    toggleDisplayBreakModal(false);
    punchInOutApiCal(PUNCH_ACTIONS.BREAK_START, breakTypeId);
  };

  const getCoordinates = async (action) => {
    return new Promise((resolve) => {
      try {
        if (navigator.userAgent === "application") {
          const latitude = window.localStorage.getItem("latitude");
          const longitude = window.localStorage.getItem("longitude");
          setTimeout(() => {
            if (latitude === null || longitude === null) {
              updateProcessingModal(false);
              displayErrorModal(
                `Please allow Geo Location to read your browser location for ${
                  action === PUNCH_ACTIONS.PUNCH_IN ? "in" : "out"
                }`
              );
              resolve({
                latitude: "",
                longitude: "",
              });
              window.Print.postMessage("access-location");
            } else if (latitude && longitude) {
              resolve({
                latitude,
                longitude,
              });
            } else {
              updateProcessingModal(false);
              displayErrorModal(
                `Please allow Geo Location to read your browser location for ${
                  action === PUNCH_ACTIONS.PUNCH_IN ? "in" : "out"
                }`
              );
              resolve({
                latitude: "",
                longitude: "",
              });
              window.Print.postMessage("access-location");
            }
          }, 1000);
        } else {
          navigator.geolocation.getCurrentPosition(
            function (location) {
              resolve({
                latitude: location.coords.latitude,
                longitude: location.coords.longitude,
              });
            },
            function (error) {
              setTimeout(() => {
                if (error.code === error.PERMISSION_DENIED) {
                  updateProcessingModal(false);
                  displayErrorModal(
                    `Please allow Geo Location to read your browser location for Check ${
                      action === PUNCH_ACTIONS.PUNCH_IN ? "in" : "out"
                    }`
                  );
                  resolve({
                    latitude: "",
                    longitude: "",
                  });
                } else {
                  updateProcessingModal(false);
                  displayErrorModal("Unable to read browser location.");
                  resolve({
                    latitude: "",
                    longitude: "",
                  });
                }
              }, 1000);
            }
          );
        }
      } catch (err) {
        setTimeout(() => {
          updateProcessingModal(false);
          displayErrorModal("Unable to read browser location.");
          resolve({
            latitude: "",
            longitude: "",
          });
        }, 1000);
      }
    });
  };

  const punchInOutApiCal = async (action, breakTypeId) => {
    if (!shiftStartTime && !shiftEndTime) {
      message?.warning("shift not assigned");
      return;
    }
    if (!locationId) {
      setLocationError(true);
      return;
    }
    setLocationError(false);
    const loginFromAnywhere = get(
      find(locationList, { location_id: locationId }),
      "login_from_anywhere",
      0
    );
    const isPunchInOut = includes(
      [PUNCH_ACTIONS.PUNCH_IN, PUNCH_ACTIONS.PUNCH_OUT],
      action
    );
    if (isPunchInOut) {
      updateProcessingModal(true);
      var { latitude = "", longitude = "" } = await getCoordinates(action);
    } else {
      updateProcessingModal(true);
    }

    if (
      (isPunchInOut && latitude !== "" && longitude !== "") ||
      !isPunchInOut
    ) {
      const locationName = locationList.find(
        (loc) => loc.location_id === locationId
      );
      const baseDeptIds = filteruser[0]?.basedepartmentid
        ? Array.isArray(filteruser[0].basedepartmentid)
          ? filteruser[0].basedepartmentid
          : String(filteruser[0].basedepartmentid)
              .split(",")
              .map((id) => id.trim())
        : [];

      const deptName = result(
        find(AllDepartmentList, (e) =>
          baseDeptIds.includes(String(e?.department_id))
        ),
        "department_name"
      );
      const {
        code,
        maxProximity = "",
        punchActionInsertedId = 0,
        breakActionInsertedId = 0,
      } = await CALL_API(`punch-in-out/${ClientId}`, "post", {
        breaktypeid: breakTypeId,
        punchinid: punchId,
        punchid: action,
        departmentname: deptName,
        departmentid: filteruser[0]?.basedepartmentid,
        fullname: userInfo?.name,
        userid: userInfo?.userid,
        breakid: breakId,
        loginlocationid: action === 1 ? parseInt(locationId) : "",
        loginlocationname: action === 1 ? locationName?.location_name : "",
        loginlatitude: action === 1 ? latitude : "",
        loginlongitude: action === 1 ? longitude : "",
        logoutlocationid: action === 2 ? parseInt(locationId) : "",
        logoutlocationname: action === 2 ? locationName?.location_name : "",
        logoutlatitude: action === 2 ? latitude : "",
        logoutlongitude: action === 2 ? longitude : "",
        skipdistancechecking: loginFromAnywhere ? true : false,
        reason: punchInOutReason,
        shiftstarttime: shiftStartTime,
        shiftendtime: shiftEndTime,
        employeeid: filteruser[0]?.employeeid,
        reportingmanager: userInfo?.reportingmanager,
      });

      updateProcessingModal(false);
      if (code === STATUS_CODE.PUNCH_IN_SUCCESSFUL) {
        setPunchInOutReason("");
        updateCheckedIn(true);
        updateCheckInLocationId(locationId);
        updateSuccessModal({
          visibility: true,
          message: `You have been checked in successfully`,
        });
        updateProcessingModal(false);
        savePunchId(punchActionInsertedId);
      } else if (code === STATUS_CODE.PUNCH_OUT_SUCCESSFUL) {
        setPunchInOutReason("");
        updateCheckedIn(false);
        updateCheckInLocationId("");
        updateSuccessModal({
          visibility: true,
          message: `You have been checked out successfully`,
        });
        updateProcessingModal(false);
        savePunchId("");
      } else if (code === STATUS_CODE.BREAK_STARTED) {
        updateIsOnBreak(true);
        updateSuccessModal({
          visibility: true,
          message: "Break has been started",
        });
        updateProcessingModal(false);
        saveBreakId(breakActionInsertedId);
      } else if (code === STATUS_CODE.REASON) {
        updateProcessingModal(false);
        setReasonValidation(false);
        setShowLateCheckInModal(true);
      } else if (code === STATUS_CODE.BREAK_ENDED) {
        updateIsOnBreak(false);
        updateSuccessModal({
          visibility: true,
          message: "Your break has been stopped",
        });
        updateProcessingModal(false);
        saveBreakId("");
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        if (isPunchInOut) {
          displayErrorModal(
            `You are already logged ${
              action === PUNCH_ACTIONS.PUNCH_IN ? "in" : "out"
            }.`
          );
        } else {
          displayErrorModal(`You are already on break`);
        }
      } else if (code === STATUS_CODE.OUTSIDE_ALLOWED_PROXIMITY) {
        displayErrorModal(
          `You are far from allowed proximity (${maxProximity} meters). Please try to get closer.`
        );
      } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
        toggleCheckInProblemModal(true);
      } else toggleCheckInProblemModal(true);
      updateProcessingModal(false);
    }
  };

  const getAssignedShiftList = async () => {
    try {
      setShiftLoader(true);
      const { data } = await CALL_API(
        `get-user-shift/${ClientId}/${userInfo?.userid}`,
        "post",
        {
          from: moment().startOf("month").format("YYYY-MM-DD"),
          to: moment().endOf("month").format("YYYY-MM-DD"),
        }
      );
      setMyShift(data);
    } catch (error) {
      console.log("[getShiftList] Error:", error);
    } finally {
      setShiftLoader(false);
    }
  };

  const stopBreak = () => {
    Modal.confirm({
      icon: "",
      content: "Are you sure you want to stop the break ?",
      okText: "YES",
      cancelText: "No",
      onOk: () => {
        punchInOutApiCal(PUNCH_ACTIONS.BREAK_END, breakId);
      },
    });
  };

  if (size(shiftTimeMaster)) {
    if (
      !punchId &&
      !isCheckInReminderModalVisible &&
      window.localStorage.getItem("login_reminder") !== "true"
    ) {
      const kenyaDateTime = getKenyanDateTime();
      const dayIndex = dateInDetail(kenyaDateTime).day_index + 1;
      const { start_time, end_time } = find(shiftTimeMaster, { day: dayIndex });
      if (start_time && end_time) {
        const dayStartTime = moment(
          `${getMySqlDate(kenyaDateTime)} ${start_time}: 00`
        );
        const dayEndTime = moment(
          `${getMySqlDate(kenyaDateTime)} ${end_time}: 00`
        );
        const actualCheckInDateTime = moment(kenyaDateTime);
        if (actualCheckInDateTime < dayEndTime) {
          const diff = actualCheckInDateTime.diff(dayStartTime, "minutes");
          if (diff) {
            toggleCheckInReminderModal(true);
          }
        }
      }
    }
  }

  const locationOptions = concat(
    { location_id: "", location_name: "Select Location" },
    orderBy(filterLocation, [(loc) => loc.location_id], ["asc"])
  );

  const departmentOptions = concat(
    { department_id: "", department_name: "Select Department" },
    orderBy(filterDepartment, [(val) => val.department_id], ["asc"])
  );

  useEffect(() => {
    if (locationOptions.length === 2) {
      setLocationId(locationOptions[1].location_id);
    }
  }, [locationOptions]);

  useEffect(() => {
    if (departmentOptions.length === 2) {
      setDepartmentId(departmentOptions[1].department_id);
    }
  }, [departmentOptions]);
  const viewAccess = Menulist?.find((item) => item?.key === "Punchinout")
    ?.permission?.view;

  useEffect(() => {
    getAssignedShiftList();
  }, [userInfo?.userid]);
  return (
    <>
      <Spin spinning={getShiftLoader}>
        {viewAccess && (
          <StyleContainerRow>
            <Col xs={24} xl={12} md={12} sm={12} className="pe-2">
              <Col span={24}>
                <div>Location</div>
              </Col>
              <Col md={24} sm={24} xs={24} ref={containerRef1}>
                <StyledLocationSelect
                  className="mt-1 w-100"
                  getPopupContainer={() => containerRef1.current}
                  placeholder="Select Location"
                  options={locationOptions}
                  fieldNames={{
                    label: "location_name",
                    value: "location_id",
                  }}
                  value={locationId}
                  onChange={(val) => setLocationId(val)}
                  status={locationError ? "error" : ""}
                  help={locationError ? "Please select a location" : ""}
                  disabled={locationOptions.length === 2}
                />
              </Col>
            </Col>
            <Col xl={24} md={24} sm={24} xs={24} className="checkin-row">
              {!isCheckedIn && (
                <StyledCheckInCheckOutButton
                  className="mt-3"
                  onClick={() => punchInOutApiCal(PUNCH_ACTIONS.PUNCH_IN, "")}
                >
                  Check-In
                </StyledCheckInCheckOutButton>
              )}
              {isCheckedIn && !isOnBreak && (
                <StyledCheckInCheckOutButton
                  className="mt-3"
                  onClick={() => punchInOutApiCal(PUNCH_ACTIONS.PUNCH_OUT, "")}
                >
                  Check-Out
                </StyledCheckInCheckOutButton>
              )}
              {isCheckedIn && (
                <Container>
                  <StyledStartBreak
                    type="text"
                    onClick={() =>
                      isOnBreak ? stopBreak() : toggleDisplayBreakModal(true)
                    }
                  >
                    <CustomIcon name={isOnBreak ? "stop_break" : "play"} />

                    {isOnBreak ? "Stop Break" : "Start Break"}
                  </StyledStartBreak>
                </Container>
              )}
            </Col>
            <BreakModal
              isModalVisible={isBreakModalVisible}
              closeModal={() => toggleDisplayBreakModal(!isBreakModalVisible)}
              startBreak={(breakTypeId) => {
                startBreak(breakTypeId);
              }}
            />
            <CheckInProblemModal
              isModalVisible={isCheckInProblemModalVisible}
              closeModal={() =>
                toggleCheckInProblemModal(!isCheckInProblemModalVisible)
              }
              tryAgain={() => punchInOutApiCal(PUNCH_ACTIONS.PUNCH_IN, "")}
            />

            <Modal
              title=""
              open={showLateCheckInModal}
              footer={false}
              onCancel={hideModal}
              okText="Submit"
              cancelText="Cancel"
              maskClosable={false}
            >
              <div className="mt-3 mb-1">
                Reason For {!isCheckedIn ? "Late Check-in" : "Early Check-out"}
              </div>
              <TextArea
                rows={4}
                name="punchInOutReason"
                value={punchInOutReason}
                onChange={handlePunchInOutReason}
              />
              {reasonValidation && (
                <div className="text-danger">*Reason is required</div>
              )}
              <div className="mt-3 d-block">
                <div className="d-flex justify-content-end">
                  <Button onClick={hideModal}>Cancel</Button>

                  <Button
                    type="primary"
                    onClick={() =>
                      getPunchInOutReason(
                        !isCheckedIn
                          ? PUNCH_ACTIONS.PUNCH_IN
                          : PUNCH_ACTIONS.PUNCH_OUT
                      )
                    }
                    className="mx-2"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Modal>
          </StyleContainerRow>
        )}
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  departmentList: getDepartmentList(state),
  locationList: getLocations(state),
  isOnBreak: getIsOnBreak(state),
  isCheckedIn: getIsCheckedIn(state),
  checkInLocationId: getCheckInLocationId(state),
  punchId: getPunchId(state),
  breakId: getBreakId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  systemTime24: getTime24(state),
  detaildate: getLongDay(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  ClientId: getClientid(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  checkInDepartmentId: getCheckInDepartmentId(state),
  weekendShifts: getWeekendShifts(state),
  menuList: getMenuList(state),
  shiftList: getShiftList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateIsOnBreak: setIsOnBreak,
      updateCheckedIn: setCheckedIn,
      updateSuccessModal: toggleSuccessModal,
      updateCheckInLocationId: setCheckInLocationId,
      updateProcessingModal: toggleProcessingModal,
      savePunchId: setPunchId,
      saveBreakId: setBreakId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckInCheckout);
